import React, { useState, useEffect } from "react";
// import man from '../assets/images/dashboard/profile.png';
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Button,
  TabContent,
  TabPane,
} from "reactstrap";
import { ToastContainer } from "react-toastify";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { ORIGIN, SERVER_URL } from "../config";

const Register = (props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState("jwt");
  const [togglePassword, setTogglePassword] = useState(false);

  async function login() {
    // history.push(`${process.env.PUBLIC_URL}/dashboard`);
    let item = { username, password };
    const response = await fetch(`${SERVER_URL}/v1/corporate/login`, {
      method: "POST",
      headers: {
        "content-Type": "application/json",
        Accept: "application/json",
        'Access-Control-Allow-Origin': ORIGIN
      },
      mode: "cors",
      body: JSON.stringify(item),
    });
    if (response.status === 200) {
      let result = await response.json();
      if (result.statusCode === 200) {
        localStorage.setItem("token", result.payload.access_token);
        // localStorage.setItem("email", username);
        history.push(`${process.env.PUBLIC_URL}/myPerformance`);
        Swal.fire({
          icon: "success",
          title: "Successfully login",
          // text: "user id or password is incorrect",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Dear Student",
          text: "user id or password is incorrect",
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Dear Student",
        text: "user id or password is incorrect",
      });
    }
  }

  const handleCorporate = () => {
    window.location.href = `${process.env.PUBLIC_URL}/login`;
  };

  return (
    <>
      <Container fluid={true} className="p-0">
        <Row>
          <Col xs="12">
            <div className="login-card">
              <div>
                <div className="login-main register-main login-tab">
                  <TabContent activeTab={selected} className="content-login">
                    <TabPane className="fade show" tabId="jwt">
                      <Form className="theme-form">
                        <h4>Register</h4>
                        <p>{"Enter all required information"}</p>
                        <div className="row">
                          <div className="col-md-6 col-sm-12 col-xs-12">
                            <FormGroup>
                              <Label className="col-form-label">Name</Label>
                              <Input
                                className="form-control"
                                type="text"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Please enter a Name",
                                  },
                                  pattern: {
                                    value: "^[A-Za-z0-9]+$",
                                    errorMessage:
                                      "Name must be composed only with letter and numbers",
                                  },
                                  minLength: {
                                    value: 6,
                                    errorMessage:
                                      "Name Id must be between 6 and 16 characters",
                                  },
                                  maxLength: {
                                    value: 16,
                                    errorMessage:
                                      "Name Id must be between 6 and 16 characters",
                                  },
                                }}
                                autocomplete="off"
                                onChange={(e) => setUsername(e.target.value)}
                                defaultValue={username}
                              />
                            </FormGroup>
                          </div>
                          <div className="col-md-6 col-sm-12 col-xs-12">
                            <FormGroup>
                              <Label className="col-form-label">Company Name</Label>
                              <Input
                                className="form-control"
                                type="text"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Please enter a Company Name",
                                  },
                                  pattern: {
                                    value: "^[A-Za-z0-9]+$",
                                    errorMessage:
                                      "Company name Id must be composed only with letter and numbers",
                                  },
                                  minLength: {
                                    value: 6,
                                    errorMessage:
                                      "Company name Id must be between 6 and 16 characters",
                                  },
                                  maxLength: {
                                    value: 16,
                                    errorMessage:
                                      "Company name Id must be between 6 and 16 characters",
                                  },
                                }}
                                autocomplete="off"
                                onChange={(e) => setUsername(e.target.value)}
                                defaultValue={username}
                              />
                            </FormGroup>
                          </div>
                          <div className="col-md-6 col-sm-12 col-xs-12">
                            <FormGroup>
                              <Label className="col-form-label">Email</Label>
                              <Input
                                className="form-control"
                                type="text"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Please enter a Email",
                                  },
                                  pattern: {
                                    value: "^[A-Za-z0-9]+$",
                                    errorMessage:
                                      "Email must be composed only with letter and numbers",
                                  },
                                  minLength: {
                                    value: 6,
                                    errorMessage:
                                      "Email must be between 6 and 16 characters",
                                  },
                                  maxLength: {
                                    value: 16,
                                    errorMessage:
                                      "Email must be between 6 and 16 characters",
                                  },
                                }}
                                autocomplete="off"
                                onChange={(e) => setUsername(e.target.value)}
                                defaultValue={username}
                              />
                            </FormGroup>
                          </div>
                          <div className="col-md-6 col-sm-12 col-xs-12">
                            <FormGroup>
                              <Label className="col-form-label">CR Number</Label>
                              <Input
                                className="form-control"
                                type="text"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Please enter a CR Number",
                                  },
                                  pattern: {
                                    value: "^[A-Za-z0-9]+$",
                                    errorMessage:
                                      "CR Number must be composed only with letter and numbers",
                                  },
                                  minLength: {
                                    value: 6,
                                    errorMessage:
                                      "CR Number must be between 6 and 16 characters",
                                  },
                                  maxLength: {
                                    value: 16,
                                    errorMessage:
                                      "CR Number must be between 6 and 16 characters",
                                  },
                                }}
                                autocomplete="off"
                                onChange={(e) => setUsername(e.target.value)}
                                defaultValue={username}
                              />
                            </FormGroup>
                          </div>
                          <div className="col-md-6 col-sm-12 col-xs-12">
                            <FormGroup>
                              <Label className="col-form-label">Upload File</Label>
                              <Input
                                className="form-control"
                                type="text"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Please enter a Upload File",
                                  },
                                  pattern: {
                                    value: "^[A-Za-z0-9]+$",
                                    errorMessage:
                                      "Upload File must be composed only with letter and numbers",
                                  },
                                  minLength: {
                                    value: 6,
                                    errorMessage:
                                      "Upload File must be between 6 and 16 characters",
                                  },
                                  maxLength: {
                                    value: 16,
                                    errorMessage:
                                      "Upload File must be between 6 and 16 characters",
                                  },
                                }}
                                autocomplete="off"
                                onChange={(e) => setUsername(e.target.value)}
                                defaultValue={username}
                              />
                            </FormGroup>
                          </div>
                          <div className="col-md-6 col-sm-12 col-xs-12">
                            <FormGroup>
                              <Label className="col-form-label">Phone Number</Label>
                              <Input
                                className="form-control"
                                type="text"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Please enter a Phone Number",
                                  },
                                  pattern: {
                                    value: "^[A-Za-z0-9]+$",
                                    errorMessage:
                                      "Phone Number must be composed only with letter and numbers",
                                  },
                                  minLength: {
                                    value: 6,
                                    errorMessage:
                                      "Phone Number must be between 6 and 16 characters",
                                  },
                                  maxLength: {
                                    value: 16,
                                    errorMessage:
                                      "Phone Number must be between 6 and 16 characters",
                                  },
                                }}
                                autocomplete="off"
                                onChange={(e) => setUsername(e.target.value)}
                                defaultValue={username}
                              />
                            </FormGroup>
                          </div>
                          <div className="col-md-6 col-sm-12 col-xs-12">
                            <FormGroup>
                              <Label className="col-form-label">Address</Label>
                              <Input
                                className="form-control"
                                type="text"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Please enter a Address",
                                  },
                                  pattern: {
                                    value: "^[A-Za-z0-9]+$",
                                    errorMessage:
                                      "Address must be composed only with letter and numbers",
                                  },
                                  minLength: {
                                    value: 6,
                                    errorMessage:
                                      "Address must be between 6 and 16 characters",
                                  },
                                  maxLength: {
                                    value: 16,
                                    errorMessage:
                                      "Address must be between 6 and 16 characters",
                                  },
                                }}
                                autocomplete="off"
                                onChange={(e) => setUsername(e.target.value)}
                                defaultValue={username}
                              />
                            </FormGroup>
                          </div>
                          <div className="col-md-6 col-sm-12 col-xs-12">
                            <FormGroup>
                              <Label className="col-form-label">City</Label>
                              <Input
                                className="form-control"
                                type="text"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Please enter a City",
                                  },
                                  pattern: {
                                    value: "^[A-Za-z0-9]+$",
                                    errorMessage:
                                      "City must be composed only with letter and numbers",
                                  },
                                  minLength: {
                                    value: 6,
                                    errorMessage:
                                      "City must be between 6 and 16 characters",
                                  },
                                  maxLength: {
                                    value: 16,
                                    errorMessage:
                                      "City must be between 6 and 16 characters",
                                  },
                                }}
                                autocomplete="off"
                                onChange={(e) => setUsername(e.target.value)}
                                defaultValue={username}
                              />
                            </FormGroup>
                          </div>
                          <div className="col-md-6 col-sm-12 col-xs-12">
                            <FormGroup>
                              <Label className="col-form-label">Postbox</Label>
                              <Input
                                className="form-control"
                                type="text"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Please enter a Postbox",
                                  },
                                  pattern: {
                                    value: "^[A-Za-z0-9]+$",
                                    errorMessage:
                                      "Postbox must be composed only with letter and numbers",
                                  },
                                  minLength: {
                                    value: 6,
                                    errorMessage:
                                      "Postbox must be between 6 and 16 characters",
                                  },
                                  maxLength: {
                                    value: 16,
                                    errorMessage:
                                      "Postbox must be between 6 and 16 characters",
                                  },
                                }}
                                autocomplete="off"
                                onChange={(e) => setUsername(e.target.value)}
                                defaultValue={username}
                              />
                            </FormGroup>
                          </div>
                          <div className="col-md-6 col-sm-12 col-xs-12">
                            <FormGroup>
                              <Label className="col-form-label">State</Label>
                              <Input
                                className="form-control"
                                type="text"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Please enter a State",
                                  },
                                  pattern: {
                                    value: "^[A-Za-z0-9]+$",
                                    errorMessage:
                                      "State must be composed only with letter and numbers",
                                  },
                                  minLength: {
                                    value: 6,
                                    errorMessage:
                                      "State must be between 6 and 16 characters",
                                  },
                                  maxLength: {
                                    value: 16,
                                    errorMessage:
                                      "State must be between 6 and 16 characters",
                                  },
                                }}
                                autocomplete="off"
                                onChange={(e) => setUsername(e.target.value)}
                                defaultValue={username}
                              />
                            </FormGroup>
                          </div>
                        </div>

                        <div className="form-group mb-0">
                          <br></br>
                          <Button
                            color="primary"
                            className="btn-block"
                            onClick={login}
                          >
                            Register
                          </Button>
                        </div>
                        <p className="mt-4 mb-0">
                          <a
                            className="ml-2 onHoverRegister"
                            onClick={handleCorporate}
                          >
                            {" "}
                            {"Already registered"}
                          </a>
                        </p>
                      </Form>
                    </TabPane>
                  </TabContent>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <ToastContainer />
      </Container>
    </>
  );
};

export default withRouter(Register);
